import React, { useState } from "react";
import { Header, ButtonFilled } from "../../../styleguide/atoms/index.js";
import { CharactersGridEl, SectionContainer } from "../styles/Game.styles.js";
import { CharacterCard } from "./CharacterCard.js";
import { renderRichText } from "../../../lib/renderRichText.js";

export default function CharactersGrid({ charactersSorted, roleAssets }) {
  const [listView, setListView] = useState(false);
  const buttonText = listView ? "Card View" : "List View";
  return (
    <SectionContainer data-list={listView ? "true" : "false"}>
      <Header type="h3" align="center">
        Role Roster
      </Header>
      <ButtonFilled text={buttonText} onClick={() => setListView((v) => !v)} />
      <CharactersGridEl>
        {charactersSorted.map((p) => {
          const asset = p.roleId ? roleAssets[p.roleId] : null;
          const isInactive = !!p.inactive;
          const title = isInactive
            ? asset?.title || ""
            : p.roleTitle || asset?.title || "";
          const role = isInactive
            ? asset?.team || ""
            : p.team || asset?.team || "";
          const description = asset?.descriptionRich
            ? renderRichText(asset.descriptionRich)
            : null;

          return (
            <CharacterCard
              key={p.id}
              image={asset?.imageUrl || ""}
              description={description}
              role={role}
              status={p.alive === false ? "Dead" : null}
              title={title}
              listView={listView}
              selected={false}
              player={p.name || ""}
            />
          );
        })}
      </CharactersGridEl>
    </SectionContainer>
  );
}
